// Pure helpers of the work statement: section and subsection choices come from the
// project and its works, never from a fixed АР/ЭОМ pair.

export const DEFAULT_CATEGORY = "Общие работы";

type Row = { discipline: string; category: string };

const byName = (a: string, b: string) => a.localeCompare(b, "ru", { numeric: true });

/** Project sections in their configured order, then sections met only in works. */
export function sectionOptions(projectSections: readonly string[], rows: readonly Row[]): string[] {
  const configured = [...new Set(projectSections.map(value => value.trim()).filter(Boolean))];
  const extra = [...new Set(rows.map(row => row.discipline))]
    .filter(value => value && !configured.includes(value)).sort(byName);
  return [...configured, ...extra];
}

/** Subsections offered for a manual work: configured ones, else the explicit catch-all,
 *  plus every subsection the section already has in the statement. */
export function categoryOptions(section: string, rows: readonly Row[], configured: Readonly<Record<string, string[]>>): string[] {
  const base = configured[section]?.length ? configured[section] : [DEFAULT_CATEGORY];
  const used = [...new Set(rows.filter(row => row.discipline === section).map(row => row.category))]
    .filter(value => value && !base.includes(value)).sort(byName);
  return [...base, ...used];
}

/** Sections typed by the estimator: comma or line separated, trimmed, without repeats. */
export function parseSections(text: string): string[] {
  return [...new Set(text.split(/[,;\n]/).map(value => value.trim().replace(/\s+/g, " ")).filter(Boolean))];
}

/** Sections that still have works in the statement; dropping them must be a visible decision. */
export function sectionsInUse(next: readonly string[], rows: readonly Row[]): string[] {
  return [...new Set(rows.map(row => row.discipline))].filter(value => value && !next.includes(value)).sort(byName);
}

/** PATCH body fragment for the building of a work: sent only when the estimator changed it,
 *  so an untouched field never turns the generated building into a manual decision. */
export function buildingChange(previous: string, typed: string): { building?: string } {
  const next = typed.trim().replace(/\s+/g, " ");
  return next === previous ? {} : { building: next };
}
